import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const OutboundContainer = styled.div`
  padding: 0 8px 8px 8px;
`

export const PhasesContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
`

export const SectionHeader = styled.div`
  color: gray;
  font-size: smaller;
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
`

export const HorizontalDivider = styled.div`
  width: 100%;
  margin: 16px 0;
  border-top: 1px solid #ddd;
`

export const VerticalDivider = styled.div`
  height: 100px;
  margin: 0 16px;
  border-left: 1px solid #ddd;
`

export const ApprovalActionContainer = styled.div`
  padding: 8px 24px;
`

export const paper = css`
  pointer-events: none;
  padding: 16px;
`

export const padding = css`
  padding: 0 8px 8px 8px;
`

export const stepper = css`
  width: 100%;
  min-width: 700px;
  padding: 0;
  pointer-events: none;
`
